import { render, staticRenderFns } from "./IssueComments.vue?vue&type=template&id=d637a76a&scoped=true"
import script from "./IssueComments.vue?vue&type=script&lang=js"
export * from "./IssueComments.vue?vue&type=script&lang=js"
import style0 from "./IssueComments.vue?vue&type=style&index=0&id=d637a76a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d637a76a",
  null
  
)

export default component.exports